import React, { Component } from 'react';

import lajitoufangchu from './assets/img/lajitoufangchu.png';

class Section$ extends Component {
    showDrawer = (data) => {
        this.props.enclosureShow(data.target.id, data.target.title)
    }
    render() {
        return (
            <div>
                <div style={{ textIndent: '2em' }}>
                    <div style={{ textAlign: 'center' }}>
                        <br />
                        <h1 name="0-9" className="point" id="0-9">第十章 后勤保障制度</h1></div>
                    <div style={{ textIndent: '2em' }}>
                        <br />
                        <h2 name="0-9-0" className="point" id="0-9-0">一、员工宿舍管理条例</h2>
                        <p>为加强宿舍安全、文明管理，保持员工宿舍良好的卫生环境及公共秩序，使员工在清洁、宁静、安全、文明的生活环境中休息，特制定本制度。</p>
                        <h3 name="0-9-0-0" className="point" id="0-9-0-0">1、有偿住宿标准</h3>
                        <p>一、员工宿舍为有偿提供，需住宿人员要提出申请经资产部同意后方可入住，床位价位标准如下：</p>
                        <p>6人间100元/床位/月；4人间150元/床位/月；2人间200元/床位/月；单人间300元/床位/月。</p>
                        <p>（如当月住宿人完全遵守宿舍管理条例，则床位费折半；如违反，则按宿舍管理条例进行积分或现金考核）</p>
                        <h3 name="0-9-0-1" className="point" id="0-9-0-1">2、申请住宿要求</h3>
                        <p>员工在工作地无适当住所者，可以申请住宿，但有以下情况者不得住宿。</p>
                        <p>1、患有传染病者；</p>
                        <p>2、有不良嗜好者，如酗酒等；</p>
                        <p>3、不遵守本条例者。</p>
                        <h3 name="0-9-0-2" className="point" id="0-9-0-2">3、宿舍卫生管理细则</h3>
                        <p>考核0-200分（元）/项，情节严重者，另议。</p>
                        <p>考核项：</p>
                        <p>1、自觉养成良好的社会公德和卫生习惯，保持宿舍内外环境卫生清洁。</p>
                        <p>2、卫生定期打扫，大家共同维持宿舍内的整洁；</p>
                        <p>3、宿舍应由住宿人员轮流进行卫生值日，保持清洁，注意通风。应做到：地面保持整洁，无污物，无污迹，室内无异味，室内食物不乱放，桌面、电器表面无灰尘、卫生间洁具无污垢；</p>
                        <p>4、个人物品、被褥码放整齐，床铺上下整齐无杂物，个人物品不得占用空床；</p>
                        <p>5、墙壁或橱柜上禁止随意张贴字画或钉东西；</p>
                        <p>6、宿舍区的公共场所禁止堆放杂物，暂时不用物品需整齐码放至储物间，并粘贴姓名贴。</p>
                        <p>7、垃圾及时清理，必须倒入指定地点；</p>
                        <p>8、衣物洗涤后按指定位置晾晒；</p>
                        <p>9、文明使用浴室及洗漱间，节约用水用电。</p>
                        <h3 name="0-9-0-3" className="point" id="0-9-0-3">4、宿舍规定及处罚条例</h3>
                        <p>考核0-200分（元）/项，情节严重者，另议。</p>
                        <p>考核项：</p>
                        <p>1、提高安全意识：宿舍内勿放私人贵重物品，出入随手关门，最后离开宿舍的人员要检查电器是否关闭并锁好门窗；</p>
                        <p>2、爱护公司配发的住宿设施、物品，做到设施、物品责任到人，如因保管不善或人为损坏、丢失应照价赔偿；</p>
                        <p>3、宿舍区内禁止饲养宠物；</p>
                        <p>4、严禁在宿舍赌博、斗殴或酗酒、留宿异性；</p>
                        <p>5、未经部门经理批准擅自外宿、申请外宿原因与实际情况不符或频繁申请外宿的，公司将取消其住宿资格。外宿期间造成的一切人身财产损失和伤亡事故，公司概不负责；</p>
                        <p>6、有偷窃等不良行为，一经发现，移交司法机关处理并终止劳动关系；</p>
                        <p>7、工作时间禁止在宿舍逗留；</p>
                        <p>8、员工迁离宿舍，不得带走舍内任何公共物品及设施，后勤部应及时收回床铺用品和门、橱柜钥匙；</p>
                        <p>9、员工离职即终止宿舍使用权，应于离职之日起两日内迁离宿舍，不得借故拖延或要求任何补偿。及时完整交齐门、橱柜钥匙，由资产部进行监督。</p>
                        <p>10、任何人员不得在员工宿舍区域进行网络直播、拍抖音视频等行为。</p>
                        <h3 name="0-9-0-4" className="point" id="0-9-0-4">5、消防安全管理</h3>
                        <p>考核0-200分（元）/项，情节严重者，另议。</p>
                        <p>1、自觉遵守各项消防安全制度；</p>
                        <p>2、不得私自乱拉乱接电线、插座，插座上的充电设备及时拔掉；</p>
                        <p>3、宿舍内不得使用电热毯、电热炊具、电熨斗等大功率电器；</p>
                        <p>4、人离熄灯，关闭电器，放长假时断电源；</p>
                        <p>5、宿舍区严禁吸烟；</p>
                        <h3 name="0-9-0-5" className="point" id="0-9-0-5">6、宿舍来访出入规定</h3>
                        <p>考核0-200分（元）/项，情节严重者，另议。</p>
                        <p>考核项：</p>
                        <p>1、外来人员必须经批准方可进入员工宿舍，来访时间限于早八点至晚十点间；</p>
                        <p>2、不得私自留宿外人；</p>
                        <p>3、非住宿的公司其他员工不得随意留宿；</p>
                        <p>4、带行李、物品出宿舍大门的员工须自觉接受相关人员的检查；</p>
                        <p>5、凡因非工作原因外出的员工必须在22：00前返回宿舍。</p>
                        <h3 name="0-9-0-6" className="point" id="0-9-0-6">7、宿舍积分考核</h3>
                        <p>对以上各项的考核权归监察部，如果没有违反者，床位费减半。监察部每月抽查评比出15名宿舍环境标兵进行奖励（其中女生3人，男生12人），当月各奖励0-200分（元）/人。四人以上宿舍每月评比出四个先进宿舍（其中女生宿舍1个，男生宿舍3个），获“先进宿舍”称号，对该宿舍人员当月各奖励0-100分（元）/人。</p>
                        <h2 name="0-9-1" className="point" id="0-9-1">二、职工食堂管理细则</h2>
                        <h3 name="0-9-1-0" className="point" id="0-9-1-0">1、目的：</h3>
                        <p>本着服务云豪集团生产经营，服务职工生活的目的，力求做到让职工有一个卫生舒适的就餐环境，能够吃到卫生可口的饭菜。为公司生产经营提供一个可持续的用餐保障，让职工满意，让公司经营者满意。</p>
                        <h3 name="0-9-1-1" className="point" id="0-9-1-1">2、食堂管理规范</h3>
                        <p>1、由资产部对职工食堂进行管理，接受食堂工作人员及就餐员工的监督。</p>
                        <p>2、后勤保障部负责食堂和餐厅的全面工作。</p>
                        <p>3、严格执行《食堂卫生法》，做好餐饮卫生、室内外环境卫生和职工个人卫生。</p>
                        <p>4、学习食堂的经营管理方案，协调食堂人员分工，做好全体食堂员工的思想工作，充分调动团队工作积极性。</p>
                        <p>5、调换菜品花样，控制饮食成本，保证食材新鲜，掌握每日餐品用量，杜绝浪费。</p>
                        <p>6、提高安全意识，加强对水、电、燃气、各种电器设备的管理使用，消除安全隐患。</p>
                        <p>7、餐厅、厨房内的设备、设施与用具等实行“定置管理”，做到摆放整齐有序、干净整洁、定期清洗消毒。</p>
                        <p>8、食堂人员每年必须进行一次健康体检，出现不适合食堂工作的情况，解除聘用。</p>
                        <p>9、非食堂人员禁止进去操作间及食堂仓库。</p>
                        <p>10、食堂设置职工意见箱，广泛听取职工意见，提升服务质量。</p>
                        <h3 name="0-9-1-2" className="point" id="0-9-1-2">3、食堂服务团队管理细则</h3>
                        <p>1、全体员工熟知并遵守云豪集团《员工手册》。</p>
                        <p>2、食堂负责人全面负责食堂菜品生产、原材料成本、原材料质量、了解量控库存，避免原材料因长期存放变质而造成浪费。</p>
                        <p>3、食堂服务人员严格控制灶、水、电、气及易耗品的节约使用。</p>
                        <p>4、食堂服务人员做到原材料的充分利用，杜绝原材料浪费。</p>
                        <p>5、食堂服务人员工作期间衣着整洁、佩戴口罩、手套等，确保卫生。</p>
                        <p>6、食堂服务人员按照员工就餐时间提前做好餐前准备，餐后及时完成清理工作。</p>
                        <p>违反上述管理细则，每项考核0-200分。 </p>
                        <h3 name="0-9-1-3" className="point" id="0-9-1-3">4、就餐员工管理细则</h3>
                        <p>1、为规范公司食堂用餐制度，加强食堂的统筹管理，保证员工就餐质量和数量，减少不必要浪费，员工采取手机小程序报餐制，持手机扫码就餐。</p>
                        <p>2、就餐时间严格按照云豪集团各基地就餐时间执行。其中大兴基地早餐7:20--8:00,午餐11：50--12:30，晚餐5：50--6:30。严格遵守公司安排的错峰就餐时间，不得提前或滞后用餐，保证在规定的时间段就餐完毕，超过规定时间餐厅不再提供用餐。</p>
                        <p>3、外来客人就餐一律实行饭卡制，无饭卡者不予用餐。</p>
                        <p>4、各部门若有外来客人有就餐需求，3人（含）以上必须在用餐2小时前通知资产部，未通知的各部门自行解决来客就餐事宜。</p>
                        <p>5、自觉维护用餐秩序，按照先后次序排队取餐，做到耐心等待和相互礼让。</p>
                        <p>6、用餐时要保持安静，禁止大声喧哗等不文明行为。</p>
                        <p>7、就餐时视自身情况，吃多少取多少，杜绝浪费，提倡光盘行动。</p>
                        <p>8、用餐时不得将饭菜残羹随意丢弃餐桌上，不得随地丢弃乱扔垃圾，用餐结束将自己就餐位置桌面清理干净。</p>
                        <p>9、就餐结束，饭菜残羹倒入专用垃圾桶，餐具放入指定容器内，由餐厅工作人员统一清理。</p>
                        <p>10、资产部每周检查一次食堂意见箱，协商采纳并改进，共同促进餐厅的健康运营。</p>
                        <p>违反上述管理细则，每项考核0-100分（元）。</p>
                        <h2 name="0-9-1-4" className="point" id="0-9-1-4">5、垃圾分类管理细则</h2>
                        <p>新版《北京市生活垃圾管理条例》已正式实施，为了规范公司的垃圾管理，为大家营造一个安全卫生的环境，同时确保垃圾投放及分类处理，我公司从2020年7月21日起开始执行垃圾分类工作。</p>
                        <h3>1、垃圾的分类：</h3>
                        <p>1.1、可回收物：回收后再加工可称为生产原料、经过整理可再利用；</p>
                        <p>1.2、有害垃圾：对人体或环境有危害的废弃物；</p>
                        <p>1.3、厨余垃圾：易腐食物垃圾；</p>
                        <p>1.4、其他垃圾：上述三种之外的垃圾。</p>
                        <p>注：装各类垃圾的塑料袋，需单独分出并投放至其他垃圾类；具体垃圾分类内容请见附件《生活垃圾分类图》。</p>
                        <h3>2、垃圾桶设置如下：</h3>
                        <p>公司已在大兴基地指定区域摆放分类垃圾桶，要求全体员工将垃圾先分类再投放，严禁混装、随意倾倒。大兴基地共设3处垃圾投放点（指示图如下），其余垃圾桶将收回停止使用。</p>
                        <img src={lajitoufangchu} alt="" style={{ width: '500px', display: 'block', margin: '0 auto' }} />

                        <h3>一、垃圾投放时间：</h3>
                        <p>每天上午7：30---8：30，其他时间不允许投放垃圾。</p>
                        <h3>四、做好垃圾分类工作：</h3>
                        <p>对未按垃圾分类要求执行者考核当事人50元/次、考核总监50元/次，并计入积分痕迹。</p>
                       
                        <div><strong style={{ color: '#6699FF' }}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure101' title="《垃圾分类管理细则》" onClick={(value) => this.showDrawer(value)}>《垃圾分类管理细则》</a></div>
                        <br />
                        <h2 name="0-9-2" className="point" id="0-9-2">三、基础设施管理细则</h2>
                        <p>一、定义</p>
                        <p>基础设施是指适用于本公司范围内建筑物以及与生活办公相关的设施、设备，例如太阳能系统、消防泵系统、空调系统、水暖系统、监控系统、照明灯具、热水器、伸缩门、垃圾房等。</p>
                        <p>以上基础设施的管理责任和维护责任归资产部，全体职工为使用方。</p>
                        <p>二、资产部的职责</p>
                        <p>1、负责整理各设备的原始档案以及使用说明。</p>
                        <p>2、制作使用说明标识，张贴悬挂令使用者可视。</p>
                        <p>3、负责明确各基础设施的分项价格，以确保使用者损坏后赔偿有据可依。</p>
                        <p>4、保证以上基础设施正常运行，如出现基础设施损坏停止运行24小时以上，无特殊原因时考核分管副总裁200分/次，分管副总裁可考核资产部负责人200分/次。</p>
                        <p>三、对相关使用者的要求</p>
                        <p>1、使用基础设施的人必须清楚它的正确使用方法，不明白使用方法者禁止动用。</p>
                        <p>2、关于用电设备在确保安全的情况下方可启动电源，同时人离开必须断电。</p>
                        <p>3、发现基础设施有异常情况时要及时上报资产部。</p>
                        <p>4、常用设施例如门锁、木床、窗户等设施若出现松动时，相关使用者应自行及时修理，无法修   理时上报资产部。禁止强行使用甚至破坏导致更严重的后果。</p>
                        <p>5、空调每两个月必须清洗一次滤网，不懂操作者及时联系资产部。（办公室由所属部门负责，宿舍由本宿舍人员负责）。</p>
                        <p>6、大型办公室个别人员因公加班，按照办公位所属范围开通照明，严禁照明全开。</p>
                        <p>7、监控设备禁止私自调看，有需要上报监察部由后勤部专人操作。</p>
                        <p>以上各项考核0-200分/项，情节严重者，另议。以上裁决权归监察部和资产部共有。</p>
                        <h2 name="0-9-3" className="point" id="0-9-3">四、车辆使用管理细则</h2>
                        <p>1、定义</p>
                        <p>公司的公用车辆分为公务车辆和维修服务车辆，公务车辆由资产部统一管理，维修服务车辆由各事业部分别对应管理，资产部监督。</p>
                        <p>2、资产部有关车辆的管理职责：</p>
                        <p>2.1 建立所有车辆的档案。</p>
                        <p>2.2 集团公司所有取得驾驶证人员必须在资产部登记备案。</p>
                        <p>2.3 所有管辖商务车辆的维护、保养、验车、保险等。</p>
                        <p>2.4 对所有集团公司资产的各种车辆要登记在册、跟踪监督，确保车辆完好、正常使用。</p>
                        <p>2.5 对所有车辆的违章查询跟踪，每周查询一次，确保谁违章谁处理。</p>
                        <p>2.6 对使用公司指标的个人车辆的合同管理。</p>
                        <p>2.7 速通卡和油卡的使用监督。</p>
                        <p>3、商务车辆的使用规范</p>
                        <p>3.1 用公司的办公系统提交用车申请，经部门经理（支持机构）/总监（营销机构）签字→行政副总裁审批签字→资产部执行后方可使用。驾驶员用车后需如实填写行车记录表并签字；</p>
                        <p>3.2 使用人每次使用车辆完毕后需整理车辆内外的卫生，保持车辆的整洁。</p>
                        <p>3.3 使用人若发现车辆存在故障信息，需及时上报给资产部。</p>
                        <p>3.4 驾驶员在行车中因个人原因违法驾驶造成扣分、罚款，由驾驶员个人承担。造成交通事故者，按交通法处理，保险公司或肇事对方不予赔偿部分参照《员工手册》第四章第一款《车辆安全管理细则》处理。</p>
                        <p>3.5 带病车辆和手续不全车辆严禁任何人动用。驾驶员在出车前、行车中、收车后要对车辆进行安全技术检查，使车辆始终处于技术完好状态。</p>
                        <p>4、车辆安全自检</p>
                        <p>每季度进行一次车辆安全自检，公务车辆由资产部进行安全自检，维修服务车辆由各事业部进行安全自检，自检表由驾驶员和部门负责人签字后交资产部存档。</p>

                        <p>以上各条对相关责任人考核0-200分/项，考核权归监察部。</p>

                        <h2 name="0-9-4" className="point" id="0-9-4">五、公用场所管理细则</h2>
                        <p>一、定义</p>
                        <p>公用场所是指集团公司各基地办公楼及会所内会议室、卫生间、走廊、活动室以及院内的停车场、商用车展场、库房外场地等区域。</p>
                        <p>公共场所管理监督权归监察部，环境管理权归资产部，使用权归全体员工。</p>
                        <p>二、资产部负责落实上述公共场所的干净、整洁、完好。有固定整理人员者，由资产部领导并指派工作；无固定责任区负责人，由资产部领导指派，全体员工有义务配合。已指定区域负责人者，按既定要求办理。</p>
                        <p>三、公共场所使用者规范</p>
                        <p>1、洗手间保证台面整洁，镜面无污点，地面干净，物品摆放整齐，无异味，便池干净无污渍；</p>
                        <p>2、严禁随地吐痰、严禁乱扔果皮、纸屑等杂物，自觉养成良好的卫生习惯。除在指定场所外，不允许饮食、吸烟，外来人员有吸烟行为，应及时制止。</p>
                        <p>3、严禁人为破坏公共财物和公共娱乐设施，误操作导致损坏者，原价赔偿。</p>
                        <p>4、公共场所要保持安静、整洁，不可大声喧哗、吵闹，不可影响他人；严禁打架斗殴、肇事、偷窃、财博、酗酒、有伤风化等违纪违法行为。</p>
                        <p>5、各部门、车间、站负责本职管辖区域和卫生分担区环境卫生清洁工作。门卫、保安负责公司大门前和厂区公共区域道路、停车场地面日常清扫工作。</p>
                        <p>6、门窗无浮尘，四周墙壁及其附属物、装饰品无蜘蛛网、浮尘；照明灯、空调上无浮尘；玻璃上无浮尘、污迹，书柜、档案柜内各类书籍资料排列整齐，无灰尘，无乱堆乱放现象；</p>
                        <p>7、办公桌椅摆放端正，干净整洁、无浮尘，物品摆放整齐，无杂物；</p>
                        <p>8、地面每天清洁，保证无污物、污水、浮土；</p>
                        <p>9、垃圾筐定时检查、清理，保证垃圾不超过筐沿；</p>
                        <p>10、公共区域环境卫生标准：公共区域道路、停车场、绿地、裸露地面无纸屑、树叶、杨柳絮等杂物，无积雪、积水、土（泥）块。</p>
                        <p>11、各部门、车间、站负责根据公司标准化管理要求，按区域落实本部门环境卫生、设备设施和安全标准化。</p>
                        <p>12、值班人员应做好办公区域和公共区域巡检工作，并做好相关记录。</p>
                        <p>以上各条相关对应的合理责任人，当月考核0-200分/项。考核权归监察部和资产部。</p>
                    </div>
                </div>;
            </div>
        )
    }
}
export default Section$;